(ns common.excel-import-templates.registry
  (:require
   [common.excel-import-templates.associated-contact :as associated-contacts]))

(defn get-template
  [{:keys [source-entity-type target-entity-type] :as args}]
  (case target-entity-type
    :entity.type/person (associated-contacts/get-template args)))
